<div class="conta-financeira">
    <section class="cf-bloco" [formGroup]="formulario">
        <h3 class="cf-bloco__titulo">Identificação</h3>
        <div class="cf-linha cf-linha--cabecalho"
            [class.cf-linha--com-cobranca]="config.exibirFormaCobranca"
            [class.cf-linha--com-conta-corrente]="config.exibirContaCorrente"
            [class.cf-linha--com-segmento]="config.exibirSegmento && formulario.value.tipoPagador === 'CLIENTE'">
            <mat-form-field class="cf-campo cf-campo--id" appearance="fill">
                <mat-label>Id</mat-label>
                <input formControlName="id" matInput readonly>
            </mat-form-field>
            <mat-form-field class="cf-campo" appearance="fill">
                <mat-label>Tipo {{ config.labelPagador }}</mat-label>
                <mat-select formControlName="tipoPagador" (selectionChange)="listarPagador.emit()" required>
                    <mat-option value="CLIENTE">Cliente</mat-option>
                    <mat-option value="FORNECEDOR">Fornecedor</mat-option>
                    <mat-option value="COLABORADOR">Colaborador</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field class="cf-campo cf-campo--segmento" appearance="fill"
                *ngIf="config.exibirSegmento && formulario.value.tipoPagador === 'CLIENTE'">
                <mat-label>{{ config.modo === 'receber' ? 'Segmento (logo do Bolepix)' : 'Segmento' }}</mat-label>
                <mat-select formControlName="segmentoId" [disabled]="bloquearCampoEdicao"
                    (selectionChange)="formulario.value.tipoPagador === 'CLIENTE' && listarPagador.emit()">
                    <mat-option [value]="null">{{ config.modo === 'receber' ? 'Padrão (logo WOW)' : 'Selecione' }}</mat-option>
                    <mat-option *ngFor="let seg of segmentos" [value]="seg.id">
                        {{ seg.nome }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field class="cf-campo cf-campo--pagador" appearance="fill">
                <mat-label>{{ config.labelPagador }}</mat-label>
                <input type="text" matInput [formControl]="myControl" [matAutocomplete]="autoPagador">
                <mat-autocomplete #autoPagador="matAutocomplete" [displayWith]="displayFn">
                    <mat-option *ngFor="let option of pagadoresLista" [value]="option">
                        {{ option.razaoSocial }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
            <mat-form-field class="cf-campo cf-campo--data" appearance="fill">
                <mat-label>Data de Vencimento</mat-label>
                <input matInput [matDatepicker]="pickerVencimento" formControlName="dtVencimento" required>
                <mat-datepicker-toggle matSuffix [for]="pickerVencimento"></mat-datepicker-toggle>
                <mat-datepicker #pickerVencimento></mat-datepicker>
            </mat-form-field>
            <mat-form-field class="cf-campo cf-campo--conta-corrente" appearance="fill" *ngIf="config.exibirContaCorrente">
                <mat-label>Conta corrente</mat-label>
                <mat-select formControlName="contaCorrenteId" [disabled]="bloquearCampoEdicao">
                    <mat-option [value]="null">Selecione</mat-option>
                    <mat-option *ngFor="let cc of contasCorrentes" [value]="cc.id">
                        {{ labelContaCorrente(cc) }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field class="cf-campo cf-campo--cobranca" appearance="fill" *ngIf="config.exibirFormaCobranca">
                <mat-label>Forma de cobrança</mat-label>
                <mat-select formControlName="formaCobranca" [disabled]="bloquearCampoEdicao">
                    <mat-option value="MANUAL">Manual</mat-option>
                    <mat-option value="BOLETO">Boleto</mat-option>
                    <mat-option value="PIX">PIX</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="cf-linha cf-linha--descricao">
            <mat-form-field class="cf-campo cf-campo--descricao" appearance="fill">
                <mat-label>Descrição</mat-label>
                <input matInput formControlName="descricao" required>
            </mat-form-field>
            <mat-form-field class="cf-campo cf-campo--documento" appearance="fill">
                <mat-label>N. Documento</mat-label>
                <input matInput formControlName="nrDocumento">
            </mat-form-field>
            <div class="cf-campo cf-campo--anexo">
                <input #inputFatura type="file" accept="image/*,application/pdf" hidden (change)="selecionarFatura.emit($event)">
                <button type="button" mat-stroked-button class="btn-anexar-arquivo"
                    *ngIf="!possuiAnexoFatura" (click)="inputFatura.click()">
                    Anexar Arquivo
                </button>
                <button type="button" mat-stroked-button class="btn-anexar-arquivo"
                    *ngIf="possuiAnexoFatura" (click)="baixarAnexo.emit('fatura')">
                    Visualizar o arquivo
                </button>
            </div>
        </div>
        <p class="cf-arquivo-hint" *ngIf="nomeArquivoFaturaSelecionado && !possuiAnexoFatura">
            {{ nomeArquivoFaturaSelecionado }} — será enviado ao salvar (PDF ou imagem, até 25 MB)
        </p>

        <div class="cf-linha cf-linha--full">
            <mat-form-field class="cf-campo" appearance="fill">
                <mat-label>Código de Barras</mat-label>
                <input matInput formControlName="codigoBarras">
            </mat-form-field>
        </div>
    </section>

    <section class="cf-bloco cf-resumo" [formGroup]="formulario">
        <h3 class="cf-bloco__titulo">Valores</h3>
        <div class="cf-resumo__campos">
            <mat-form-field appearance="fill">
                <mat-label>Parcela</mat-label>
                <input matInput formControlName="parcela" [readonly]="bloquearCampoEdicao" required>
            </mat-form-field>
            <mat-form-field appearance="fill">
                <mat-label>Valor Lançado</mat-label>
                <input formControlName="valor" matInput currencyMask
                    [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                    (ngModelChange)="calcularTotal.emit()" required>
            </mat-form-field>
            <mat-form-field appearance="fill">
                <mat-label>Valor Desconto</mat-label>
                <input formControlName="desconto" matInput currencyMask
                    [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                    (ngModelChange)="calcularTotal.emit()">
            </mat-form-field>
            <mat-form-field appearance="fill">
                <mat-label>Juros</mat-label>
                <input formControlName="juros" matInput currencyMask
                    [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                    (ngModelChange)="calcularTotal.emit()">
            </mat-form-field>
            <mat-form-field appearance="fill">
                <mat-label>Multa</mat-label>
                <input formControlName="multa" matInput currencyMask
                    [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                    (ngModelChange)="calcularTotal.emit()">
            </mat-form-field>
            <mat-form-field appearance="fill">
                <mat-label>{{ config.labelTotal }}</mat-label>
                <input formControlName="total" matInput readonly currencyMask
                    [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }">
            </mat-form-field>
        </div>
        <div class="cf-resumo__status">
            <div class="cf-resumo__item">
                <span class="cf-resumo__label">Valor {{ config.modo === 'pagar' ? 'Pago' : 'Recebido' }}</span>
                <span class="cf-resumo__valor cf-resumo__valor--verde">{{ valorPago | currency:'BRL' }}</span>
            </div>
            <div class="cf-resumo__item">
                <span class="cf-resumo__label">Valor Restante</span>
                <span class="cf-resumo__valor cf-resumo__valor--verde">{{ valorRestante | currency:'BRL' }}</span>
            </div>
            <div class="cf-resumo__item">
                <span class="cf-resumo__label">{{ config.labelStatus }}</span>
                <span class="cf-resumo__valor cf-resumo__valor--verde"
                    [class.cf-resumo__valor--aberto]="valorRestante > 0">{{ statusPagamento }}</span>
            </div>
        </div>
    </section>

    <!-- Dados banco / Sicoob (conta a receber) -->
    <section class="cf-banco" [formGroup]="formulario" *ngIf="exibirDadosCobranca()">
        <div class="cf-banco__titulo">Dados da cobrança bancária</div>
        <div class="cf-banco__status" *ngIf="formulario.value.statusCobrancaSicoob || formulario.value.mensagemCobrancaSicoob">
            <span class="cf-banco__badge" *ngIf="formulario.value.statusCobrancaSicoob">
                Status Sicoob: {{ formulario.value.statusCobrancaSicoob }}
            </span>
            <span class="cf-banco__msg" *ngIf="formulario.value.mensagemCobrancaSicoob">
                {{ formulario.value.mensagemCobrancaSicoob }}
            </span>
        </div>
        <div class="cf-banco__grid" *ngIf="exibirBlocoBoleto()">
            <mat-form-field appearance="fill">
                <mat-label>Nosso número</mat-label>
                <input matInput formControlName="nossoNumero" [readonly]="camposBancoReadonly()">
            </mat-form-field>
            <mat-form-field appearance="fill" class="cf-banco__campo-largo">
                <mat-label>Linha digitável</mat-label>
                <input matInput formControlName="linhaDigitavel" [readonly]="camposBancoReadonly()">
            </mat-form-field>
            <div class="cf-banco__acoes" *ngIf="formulario.value.urlBoletoPdf">
                <button type="button" mat-stroked-button color="primary" (click)="abrirUrlBoleto()">
                    <mat-icon>picture_as_pdf</mat-icon> Abrir boleto PDF
                </button>
            </div>
        </div>
        <div class="cf-banco__grid cf-banco__grid--pix" *ngIf="exibirBlocoPix()">
            <mat-form-field appearance="fill">
                <mat-label>TXID PIX</mat-label>
                <input matInput formControlName="txidPix" [readonly]="camposBancoReadonly()">
            </mat-form-field>
            <div class="cf-banco__pix-copia" *ngIf="formulario.value.pixCopiaECola">
                <label class="cf-banco__pix-label">PIX copia e cola</label>
                <textarea matInput readonly rows="4" class="cf-banco__pix-texto"
                    [value]="formulario.value.pixCopiaECola"></textarea>
                <div class="cf-banco__acoes">
                    <button type="button" mat-stroked-button (click)="copiarPix.emit(formulario.value.pixCopiaECola)">
                        <mat-icon>content_copy</mat-icon> Copiar PIX
                    </button>
                    <button type="button" mat-stroked-button color="primary" (click)="baixarBolepix.emit()"
                        *ngIf="temContaSalva">
                        <mat-icon>picture_as_pdf</mat-icon> Baixar Bolepix
                    </button>
                </div>
            </div>
            <div class="cf-banco__qrcode" *ngIf="formulario.value.pixCopiaECola">
                <label class="cf-banco__pix-label">QR Code para o cliente</label>
                <img [src]="urlQrCodePix(formulario.value.pixCopiaECola)" alt="QR Code PIX" width="220" height="220">
            </div>
        </div>
    </section>

    <!-- Baixas -->
    <section class="baixas-pagamento" [class.baixas-pagamento--bloqueada]="!temContaSalva">
        <div class="baixas-pagamento__titulo">{{ config.tituloBaixas }}</div>
        <div class="cf-alerta" *ngIf="!temContaSalva">
            <mat-icon>info</mat-icon>
            Salve a conta para liberar o registro da baixa.
        </div>
        <div class="baixas-pagamento__corpo" *ngIf="temContaSalva">
            <div class="baixas-pagamento__form-row" [formGroup]="baixaForm">
                <mat-form-field class="baixas-pagamento__campo-forma" appearance="fill">
                    <mat-label>{{ config.labelFormaBaixa }}</mat-label>
                    <mat-select formControlName="formaPagamento" [disabled]="!contaAberta">
                        <mat-option value="DINHEIRO">Dinheiro</mat-option>
                        <mat-option value="CARTAO">Cartão</mat-option>
                        <mat-option value="PIX">PIX</mat-option>
                        <mat-option value="PERMUTA">Permuta</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field class="baixas-pagamento__campo-valor" appearance="fill">
                    <mat-label>Valor</mat-label>
                    <input matInput formControlName="valor" currencyMask
                        [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }">
                </mat-form-field>
                <mat-form-field class="baixas-pagamento__campo-data" appearance="fill">
                    <mat-label>{{ config.labelDataBaixa }}</mat-label>
                    <input matInput [matDatepicker]="pickerBaixa" formControlName="dataPagamento" [readonly]="!contaAberta">
                    <mat-datepicker-toggle matSuffix [for]="pickerBaixa" [disabled]="!contaAberta"></mat-datepicker-toggle>
                    <mat-datepicker #pickerBaixa></mat-datepicker>
                </mat-form-field>
                <div class="baixas-pagamento__arquivo">
                    <input #inputBaixa type="file" accept="image/*,application/pdf" hidden
                        (change)="selecionarComprovante.emit($event)">
                    <button type="button" mat-stroked-button (click)="inputBaixa.click()" [disabled]="!contaAberta">
                        Procurar...
                    </button>
                    <span class="baixas-pagamento__arquivo-nome">
                        {{ nomeArquivoBaixaSelecionado || 'Nenhum arquivo selecionado.' }}
                    </span>
                </div>
            </div>
            <div class="baixas-pagamento__acoes">
                <button type="button" mat-stroked-button class="btn-adicionar-baixa"
                    (click)="registrarBaixa.emit()"
                    [disabled]="!contaAberta || baixaForm.invalid">
                    Confirmar baixa
                </button>
            </div>
            <p class="cf-dica-baixa">Comprovante é opcional (PDF ou imagem, até 25 MB).</p>
            <table class="baixas-pagamento__tabela">
                <thead>
                    <tr>
                        <th>Forma de Pagamento</th>
                        <th>Valor</th>
                        <th>{{ config.labelDataBaixa }}</th>
                        <th>Comprovante</th>
                        <th>Opções</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let linha of baixas">
                        <td>{{ labelForma(linha.formaPagamento) }}</td>
                        <td>{{ linha.valor | currency:'BRL' }}</td>
                        <td>{{ linha.dataPagamento }}</td>
                        <td>
                            <button type="button" mat-icon-button *ngIf="linha.possuiComprovante"
                                (click)="baixarAnexo.emit('baixa')" matTooltip="Baixar comprovante">
                                <mat-icon>attach_file</mat-icon>
                            </button>
                            <button type="button" mat-icon-button
                                *ngIf="!linha.possuiComprovante && linha.formaPagamento === 'PIX'"
                                (click)="baixarComprovantePix.emit()" matTooltip="Gerar comprovante PIX">
                                <mat-icon>picture_as_pdf</mat-icon>
                            </button>
                            <span *ngIf="!linha.possuiComprovante && linha.formaPagamento !== 'PIX'">—</span>
                        </td>
                        <td>—</td>
                    </tr>
                    <tr *ngIf="!baixas.length">
                        <td colspan="5" class="baixas-pagamento__tabela-empty">Nenhuma baixa registrada.</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </section>

    <section class="cf-bloco" [formGroup]="formulario">
        <h3 class="cf-bloco__titulo">Observação</h3>
        <mat-form-field class="cf-campo" appearance="fill">
            <mat-label>Observação</mat-label>
            <textarea formControlName="observacao" matInput rows="3"></textarea>
        </mat-form-field>
    </section>
</div>
